module.exports = __webpack_public_path__ + "static/media/typeD.04d24dac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hotspots/landing/typeD.png
// module id = 1252
// module chunks = 0